
import Vue from 'vue'
import { VIcon } from 'vuetify/lib'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import { navList } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcNavRouterLinkHref',
  components: {
    JcdcBtn,
    VIcon,
  },
  props: {
    item: { type: Object as () => navList, required: true },
    menuLevel: { type: Number, default: 0 },
  },
})
